/**
 * お知らせ CSV アップロードのプレビュー表示用ヘルパー。
 * バリデーション（informationCsvValidation.ts）とは別の表示専用ロジックで、
 * アップロードされる CSV 本体には影響しない。
 */

const PLATFORM_LABELS = ['Web', 'iOS', 'Android'] as const;

/**
 * プレビューの platform 列（3 桁の 0/1）に対象プラットフォーム名を併記する
 * （例: `110` → `110（Web / iOS）`。SBI #865 の管理コンソール AC）。
 * 3 桁 0/1 以外の値（検証エラーになる値）はそのまま表示する。
 */
export const formatInformationCell = (column: string, value: string): string => {
  if (column !== 'platform' || !/^[01]{3}$/.test(value)) return value;
  const names = PLATFORM_LABELS.filter((_, i) => value[i] === '1');
  // names が空になるのは 000 のみで V08 の検証で必ず弾かれるが、表示側は防御的に生値を返す
  return names.length > 0 ? `${value}（${names.join(' / ')}）` : value;
};
